// extracted by mini-css-extract-plugin
export default {"emptySearchContainer":"EmptySearch_emptySearchContainer__Svj5s","emptySearch":"EmptySearch_emptySearch__tmDgf"};